import React, {useMemo, useState, PropsWithChildren} from 'react'

interface IProps {
  email: string
  setEmail: (email: string) => void
  token: string
  setToken: (token: string) => void
  twoFactorMethod: number
  setTwoFactorMethod: (twoFactorMethod: number) => void
}

export const AuthContext = React.createContext<IProps>({
  email: '',
  setEmail: (email: string) => {},
  token: '',
  setToken: (token: string) => {},
  twoFactorMethod: 0,
  setTwoFactorMethod: (token: number) => {},
})

export const AuthContextProvider: React.FC<PropsWithChildren> = ({children}) => {
  const [email, setEmail] = useState<string>('')
  const [token, setToken] = useState<string>('')
  const [twoFactorMethod, setTwoFactorMethod] = useState<number>(0)

  const value: IProps = useMemo(() => {
    return {
      email,
      setEmail,
      token,
      setToken,
      twoFactorMethod,
      setTwoFactorMethod,
    }
  }, [email, setEmail, token, setToken, twoFactorMethod, setTwoFactorMethod])

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
